module.exports = __webpack_public_path__ + "static/media/example-2.d17e962e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/PrinceHotel/example-2.jpg
// module id = 252
// module chunks = 0